module.exports = __webpack_public_path__ + "static/media/dog3.2132adb6.jpeg";